import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconGisAttributesSizeS from './IconGisAttributes_size_s';

const props: CreateIconArguments = {
  l: IconGisAttributesSizeS,
  m: IconGisAttributesSizeS,
  s: IconGisAttributesSizeS,
  xs: IconGisAttributesSizeS,
  name: 'IconGisAttributes',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
